import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7db5a03b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db5a03b')) {
      api.createRecord('7db5a03b', component.options)
    } else {
      api.reload('7db5a03b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7db5a03b", function () {
      api.rerender('7db5a03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tree/index.vue"
export default component.exports